import httpRequest from '@/utils/request.js';
// 短链接
// 获取异常详情
export const getExDetail = id =>
    httpRequest.httpGet({
        url: `/service/d/ex/detail`,
        params: {
            id
        }
    });

// 处理异常
export const handleEx = data => httpRequest.httpPost('/service/d/ex/handle', data);
